// extracted by mini-css-extract-plugin
var _1 = "RequestProfileWidgetListColumns-modulecolumn__wQE8c";
var _2 = "RequestProfileWidgetListColumns-moduletwoColumns__o81ie";
export { _1 as "column", _2 as "twoColumns" }
